import { Cell, Paragraph, Grid, Row, Skeleton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { Couple } from '@fs/zion-person'

type Props = {
  isSmallScreen: boolean
}

export default function ParentChildHeaderSkeleton({ isSmallScreen }: Props): JSX.Element {
  const [t] = useTranslation()
  const RowOrGrid = isSmallScreen ? Grid : Row
  return (
    <RowOrGrid>
      <Cell>
        <Paragraph>{t('tree-person.child.label')}</Paragraph>
        <div
          style={{
            /* This Separator is for consistency with Couple's wrapper  */
            height: 10,
          }}
        />
        <Skeleton.PersonBlock size="sm" />
      </Cell>

      <Cell>
        <Paragraph>{t('tree-person.parents.label')}</Paragraph>
        <Couple noBoldName spouse1Obj={{}} spouse2Obj={{}} loading />
      </Cell>
    </RowOrGrid>
  )
}
